import ga from '../utils/ga'

export const reportExperimentEnrolment = ({
  experimentId,
  variant
}: {
  experimentId: string
  variant: string
}) => {
  ga('set', 'expId', experimentId)
  ga('set', 'expVar', variant)
  ga('send', {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction: 'view',
    eventLabel: experimentId,
    eventValue: variant,
    nonInteraction: true
  })
}
